type NavigationKind = 'push' | 'replace' | 'pop' | 'hash'

type Listener = (kind: NavigationKind) => void

const storeKey = Symbol.for('loomduct.navigation')

function notify(listeners: Set<Listener>, kind: NavigationKind): void {
  for (const listener of listeners) {
    try {
      listener(kind)
    } catch {}
  }
}

export function onNavigation(listener: Listener): () => void {
  const store = globalThis as unknown as Record<
    symbol,
    Set<Listener> | undefined
  >
  let listeners = store[storeKey]
  if (!listeners) {
    const created = new Set<Listener>()
    listeners = created
    store[storeKey] = created
    const wrap = (
      method: 'pushState' | 'replaceState',
      kind: NavigationKind,
    ) => {
      const original = history[method]
      history[method] = function (
        this: History,
        ...args: Parameters<History['pushState']>
      ) {
        original.apply(this, args)
        notify(created, kind)
      }
    }
    wrap('pushState', 'push')
    wrap('replaceState', 'replace')
    addEventListener('popstate', () => {
      notify(created, 'pop')
    })
    addEventListener('hashchange', () => {
      notify(created, 'hash')
    })
  }
  const current = listeners
  current.add(listener)
  return () => {
    current.delete(listener)
  }
}
